import React, { ChangeEvent, FocusEvent } from "react";
import { v4 as uuid } from "uuid";

import "./text-area-field.styles.css";

export interface TextAreaFieldProps {
  customClassName?: string;
  label?: string;
  placeholder?: string;
  value?: string;
  isDisabled?: boolean;
  errorMessage?: string | null;
  onChange?: (value: string) => void;
  onBlur?: (event: FocusEvent<HTMLTextAreaElement>) => void;
}

const TextAreaField = (props: TextAreaFieldProps): JSX.Element => {
  const {
    customClassName,
    label,
    placeholder = "",
    value,
    isDisabled,
    errorMessage,
    onChange,
    onBlur,
  } = props;

  const INPUT_ID = uuid();

  const handleOnChange = (event: ChangeEvent<HTMLTextAreaElement>): void =>
    onChange ? onChange(event.target.value) : undefined;

  return (
    <div
      className={`textarea-field ${customClassName || ""}${
        isDisabled ? " textarea-field--disabled" : ""
      }`}
    >
      {label && (
        <label htmlFor={INPUT_ID} className="textarea-field__label">
          {label}
        </label>
      )}
      <div className="textarea-field__textarea-container">
        <textarea
          id={INPUT_ID}
          className={`textarea-field__textarea ${
            errorMessage ? " textarea-field__textarea--error" : ""
          }`}
          placeholder={placeholder}
          value={value}
          onChange={handleOnChange}
          disabled={isDisabled}
          onBlur={onBlur}
        />
        <span
          className={`textarea-field__error-message${
            errorMessage ? " textarea-field__error-message--visible" : ""
          }`}
        >
          {errorMessage}
        </span>
      </div>
    </div>
  );
};

export default TextAreaField;
